import React, { useEffect, useState } from 'react';
import Alert from '../components/Alert';
import loginStyles from '../../../stylesheets/components/login.module.scss';

const SUPPORT_EMAIL = 'support@propertymatrix.com';
const SUPPORT_DIRECTED_MESSAGE_PATTERN =
  /\bcontact\s+(?:property matrix\s+)?support\b|\bproperty matrix support\b/i;

interface SomethingWentWrongAlertProps {
  body: string;
  onDismiss?: () => void;
  resetKey?: unknown;
}

const SomethingWentWrongAlert = ({
  body,
  onDismiss,
  resetKey,
}: SomethingWentWrongAlertProps) => {
  const trimmedBody = body.trim();
  const [isAlertDismissed, setIsAlertDismissed] = useState(false);

  useEffect(() => {
    setIsAlertDismissed(false);
  }, [trimmedBody, resetKey]);

  if (trimmedBody === '' || isAlertDismissed) return null;

  const includesSupport = SUPPORT_DIRECTED_MESSAGE_PATTERN.test(trimmedBody);
  const handleClose = () => {
    setIsAlertDismissed(true);
    onDismiss?.();
  };

  return (
    <Alert
      dataTestClass="login-error-banner"
      onClose={handleClose}
      severity="error"
      title={
        <span data-test-class="login-error-banner-title">
          Something went wrong
        </span>
      }
    >
      <span data-test-class="login-error-banner-body">{trimmedBody}</span>
      {includesSupport && (
        <>
          {' '}
          <a
            className={loginStyles.loginAlertLink}
            href={`mailto:${SUPPORT_EMAIL}`}
          >
            Contact support
          </a>
        </>
      )}
    </Alert>
  );
};

export default SomethingWentWrongAlert;
